export default __webpack_public_path__ + "static/media/celo-logo.faaa57f7.svg";